import styled from 'styled-components'
import { SpaceProps, space, WidthProps, width } from 'styled-system'

import { Flex } from '@/atoms/layout'
import { filterStyledSystemProps } from '@/helpers/styled-props'

export const RadioWrapper = styled(Flex).withConfig({
  shouldForwardProp: filterStyledSystemProps(),
})<WidthProps & SpaceProps & { $vertical: boolean; $disabled: boolean }>`
  align-items: center;
  position: relative;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.8 : 1)};
  height: ${({ $vertical }) => ($vertical ? 'auto' : '32px')};

  &:not(:last-of-type) {
    padding-bottom: ${({ theme, $vertical }) => ($vertical ? theme.space.S12 : 0)};
    padding-right: ${({ theme, $vertical }) => ($vertical ? 0 : theme.space.S16)};
  }
  ${width}
  ${space}
`

export const HiddenRadio = styled.input`
  position: absolute;
  opacity: 0;
  height: 100%;
  width: 100%;
  margin: 0;
  cursor: inherit; /* Inherit cursor style from parent */
`

export const StyledRadio = styled.div<{ $selected: boolean; $hasError: boolean }>`
  height: 16px;
  width: 16px;
  border: 1px solid
    ${({ theme, $hasError, $selected }) => ($hasError ? theme.colors.error : $selected ? theme.colors.violet : theme.colors.grey)};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  &::before {
    content: '';
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background-color: ${({ theme, $selected }) => ($selected ? theme.colors.violet : 'transparent')};
    box-sizing: border-box;
  }
`

export default RadioWrapper
